/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect } from 'react';

import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMeetingStatus } from 'utils/contexts/meeting-status-context';
import ImageType from 'utils/constants/imageType';
import CardAlertContainer from 'shared/components/alert-card/alert-card.component';
import SecondaryButton from 'shared/components/button/secondary-button';
import Page from 'components/page/page.component';

const ThankYou: FC = () => {
  const { isInMeeting, isInterpreterConnected, resetInterpreterRequest } =
    useMeetingStatus();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isInMeeting || !isInterpreterConnected) {
      navigate('/');
    }
  }, [isInMeeting, isInterpreterConnected]);

  return (
    <Page
      title='Thank you for choosing Sorenson for Zoom.'
      pageTitle='Thank you'
      imageOption={ImageType.Ready}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          width: '280px',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          marginTop: '48px',
        }}
      >
        <CardAlertContainer
          severity='success'
          mainText='An interpreter has accepted your request.'
        />
        <Box sx={{ width: '280px', textAlign: 'left' }}>
          <Typography
            sx={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '20px' }}
          >
            Some tips for a successful meeting with your interpreters:
          </Typography>
          <ul>
            <li style={{ marginBottom: '6px' }}>‘Admit’ their audio</li>
            <li style={{ marginBottom: '6px' }}>Share the meeting topic</li>
            <li>Allow multi-pin</li>
          </ul>
        </Box>
        <Typography sx={{ color: 'secondary.contrastText' }}>
          Did the interpreter unexpectedly leave the meeting?
        </Typography>
        <SecondaryButton
          onClick={resetInterpreterRequest}
          sx={{
            textTransform: 'unset !important',
          }}
        >
          Request an interpreter again
        </SecondaryButton>
      </Box>
    </Page>
  );
};

export default ThankYou;